import { render, staticRenderFns } from "./ProductSpecsElementView.vue?vue&type=template&id=e8628848"
import script from "./ProductSpecsElementView.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8628848')) {
      api.createRecord('e8628848', component.options)
    } else {
      api.reload('e8628848', component.options)
    }
    module.hot.accept("./ProductSpecsElementView.vue?vue&type=template&id=e8628848", function () {
      api.rerender('e8628848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecsElement/ProductSpecsElementView.vue"
export default component.exports